import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faFilePdf, faPrint, faSearch, faFileExcel,
  faTrash, faPen, faQuestionCircle, faHome
} from '@fortawesome/free-solid-svg-icons'

library.add(faFilePdf, faPrint, faSearch,
  faFileExcel, faTrash, faPen, faQuestionCircle,
  faHome
);